import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { SolutionLinkDialogComponent } from './review-solution-link-dialog.component';

@Injectable()
export class ReviewSolutionLinkDialogService extends AbstractDialogService<void, void> {
  readonly id = 'solution-link';
  protected readonly component = SolutionLinkDialogComponent;

  override readonly options = {
    cssClass: 'auto-height solution-link-dialog',
  };
}
